import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FooterView, Footer, PageHeading } from 'src/common';
import { NotificationsList } from 'src/shared';
import { faBell } from '@fortawesome/pro-light-svg-icons';
import styles from './index.module.scss';

export const NotificationsPage: FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <PageHeading title={t('Navigation.Settings.notifications')} icon={faBell} />
      <div className={styles.content}>
        <NotificationsList showMarkDown={true} />
        <Footer view={FooterView.full} />
      </div>
    </div>
  );
};

export default NotificationsPage;
